import { useCifraClient } from './cifra-client';

const { cifraClient } = useCifraClient();

export default {
  list(parametros = {}) {
    return cifraClient.get('/api_publica/v1/incidencias', {
      params: parametros,
    });
  },
  listPorGrupo(grupoId) {
    return this.list({ grupo_id: grupoId });
  },
  listParaAlumno(
    alumnoId,
    annoLectivoId,
    fechaDesde = null,
    fechaHasta = null,
  ) {
    return this.list({
      alumno_id: alumnoId,
      anno_lectivo_id: annoLectivoId,
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta,
    });
  },
};
